import { Component } from '@angular/core';
import { SscShellComponent } from '../ssc-shell/ssc-shell';

@Component({
  selector: 'app-quality-dashboard-page',
  standalone: true,
  imports: [SscShellComponent],
  templateUrl: './quality-dashboard.html',
})
export class QualityDashboardPage {}
